//#region imports
import { Injectable } from '@angular/core';
import { AppConstants } from '../app.constants';
import { Router } from '@angular/router';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class SectionService {
  //#region variables
  isRetrieveSimulation = false;
  currentPage: string;
  clientIdPresent = false;
  //#endregion

  //#region methods
  constructor(private router: Router) { }

  navigate(sectionName, clientIdValue, simulationTokenValue, languageValue) {
    languageValue = (languageValue === undefined || languageValue === null) ? AppConstants.Languages.DefaultLanguage : languageValue;
    if (clientIdValue !== undefined && clientIdValue !== null) {
      this.router.navigate(['/' + sectionName], { queryParams: { clientId: clientIdValue } });
    } else if (simulationTokenValue !== undefined && simulationTokenValue !== null) {
      this.router.navigate(['/' + sectionName], { queryParams: { simulationToken: simulationTokenValue } });
    } else {
      this.router.navigate(['/' + sectionName]);
    }
  }

  setCurrentPage(value: string) {
    this.currentPage = value;
  }

  getCurrentPage(): string {
    return this.currentPage;
  }

  setClientIdPresent(value: boolean) {
    this.clientIdPresent = value;
  }

  getClientIdPresent(): boolean {
    return this.clientIdPresent;
  }

  setIsRetrieveSimulation(value: boolean) {
    this.isRetrieveSimulation = value;
  }

  getIsRetrieveSimulation(): boolean {
    return this.isRetrieveSimulation;
  }

  validateEmailId(emailId) {
    const emailIdRegexPattern = AppConstants.EmailIdRegexPattern;
    return emailIdRegexPattern.test(emailId) ? true : false;
  }

  validatePhoneNumber(phoneNumber): boolean {
    const phoneNumberRegexPatterns = AppConstants.PhoneNumberRegexPatterns;
    for (const pattern of phoneNumberRegexPatterns) {
      if (pattern.test(phoneNumber)) {
        return true;
      }
    }
    return false;
  }
  //#endregion
}
